export const NFT_GENERATE_SEAL_LIST_REQUEST = 'NFT_GENERATE_SEAL_LIST_REQUEST';

export const NFT_GENERATE_LIST_REQUEST = 'NFT_GENERATE_LIST_REQUEST';

export const NFT_GENERATE_CREATE_REQUEST = 'NFT_GENERATE_CREATE_REQUEST';

export const NFT_GENERATE_DETAIL_REQUEST = 'NFT_GENERATE_DETAIL_REQUEST';

export const NFT_GENERATE_REMOVE_REQUEST = 'NFT_GENERATE_REMOVE_REQUEST';

export const NFT_GENERATE_START_CREATING_REQUEST = 'NFT_GENERATE_START_CREATING_REQUEST';

export const NFT_GENERATE_ITEM_LIST_REQUEST = 'NFT_GENERATE_ITEM_LIST_REQUEST';

export const NFT_GENERATE_ITEM_CREATE_REQUEST = 'NFT_GENERATE_ITEM_CREATE_REQUEST';

export const NFT_GENERATE_ITEM_REMOVE_REQUEST = 'NFT_GENERATE_ITEM_REMOVE_REQUEST';
